
import { Component, Inject, OnChanges, SimpleChanges, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { NotificationTypes } from 'src/app/app.enums';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import {
  ArtistPortfolioProductsService, portfolioData, SavePortfolioProducts, SelectedGlaze, ShareableProductLink, ShareableProductsResponse,
} from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import {
  ArtistProductsService, ArtistProductsSummaryRequest, ArtistProductSummary, ConsignedProductsRequest, Product,
} from 'src/app/Services/artistproducts.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import {
  AuthConfig, AuthService, ResponseObject,
} from 'src/app/Services/auth.service';
import { CategoryService } from 'src/app/Services/category.service';
import { ConnectionsService } from 'src/app/Services/connections.service';
import { ConsignmentService, GalleryConsignmentProduct } from 'src/app/Services/consignment.service';
import { SeriesService } from 'src/app/Services/series.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { StripePlans } from 'src/app/models/stripe.model';
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { ImageUtils } from 'src/app/shared/utils/image-utils';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'shareable-product',
    templateUrl: './shareable-product.component.html',
    styleUrls: ['./shareable-product.component.css'],
    providers: [
        ArtistsService,
        ArtistProductsService,
        SeriesService,
        CategoryService,
        SubscriptionRulesService,
        ArtistPortfolioProductsService,
    ],
    standalone: false
})
export class ShareableProductComponent {
  // products array
  public artistProducts: ArtistProductSummary[] = [];
  public galleryProducts: ArtistProduct[] = [];
  // selected product 
  public selectedProduct!: ArtistProductSummary;
  public selectedGalleryProduct!: ArtistProduct
  public artistProduct!: ArtistProductSummary;
  // selected products array
  public selectedArtistProductsInventory: ArtistProductSummary[] = [];
  public selectedGalleryProductsInventory: ArtistProduct[] = [];
  public filters: ArtistProductsSummaryRequest = {};
  public selectedProducts: string[] = [];
  public artistId!: string;
  public galleryId!: string;
  public numberOfColumnToShow: number | null = null;
  // flags
  public isArtist: boolean = false;
  public isGallery: boolean = false;
  public isProductSelected: boolean = false;
  public isCurrentInventoryLoaded: boolean = false;
  public loadingArtistProducts: boolean = false;
  public loadingGalleryProducts: boolean = false;
  public isPageConfigrationDailogVisible: boolean = false;
  public isShareableProductDailogVisible: boolean = false;
  public displayPortfolioDialog: boolean = false;
  public isUpgreadAccountDialogVisible: boolean = false;
  public sidebarVisible: boolean = false;
  public showProductDialog = false;
  public isStripePlansDialogVisible: boolean = false
  public isShowProfile!: boolean;
  public currentAvailableArtworks: number = 0;
  public authConfig: AuthConfig = {};
  public uerInformation!: ShareableProductLink;
  public copiedIndex: string | null = null;
  public recentSalesProducts: Product[] = [];
  // portfolio
  public portfolio = new portfolioData();
  public portfolioList: portfolioData[] = [];
  public artistArtTypes: SelectItem[] = [];
  public productCategories: SelectItem[] = [];
  public productSeries: SelectItem[] = [];
  public galleries: SelectItem[] = [];
  public statusFilterOptions: SelectItem[] = [];
  public connectedArtists: SelectItem[] = [];
  public artTypes: SelectItem[] = [];
  public selectedArtistId: SelectItem<any> | undefined;
  public copied: boolean = false;
  public copiedRowLink: boolean = false;
  // profile information
  public ProfilePicture!: string;
  public BusinessName!: string;
  public AboutMe!: string;
  public CreatedDate?: Date;
  public SharedBy!: string;
  public Title: string | undefined;
  public portfolioselections: boolean = false;
  public collapsed: boolean = false;
  public portfolioId: string = '';
  public productLimits!: number;
  public isProductShareDailogVisible = false;
  public isEditMode: boolean = false
  public showMenuButton = false;
  public savePortfolioProductsButton = false;
  public showPortfolioProducts: boolean = false;
  public isEditPortfolioProducts: boolean = false
  public isFreePlanUser: boolean = false
  public generatedLinkId!: string;
  public shareLink: string = '';
  public sharePortfolioRowLink: string = '';
  public SharedById: string = '';
  public UserName: string = '';
  public IsSharedByArtist: boolean = false;
  public isLimitDialogVisible: boolean = false;
  public canGeneratePortolio: boolean = false;
  public isNotificationShown: boolean = false;
  public applyConfigrationSettings: boolean = false;
  public isActive: boolean | undefined
  statusOptions = [{ label: 'Active', value: true }, { label: 'Inactive', value: false },];
  public selectedRowId: string | null = null;
  public dragStartIndex: number | null = null;
  public stripePlans: StripePlans[] = [];
  public NumberOfArtistPortfolios: number = 0;
  dynamicTop: string = '50%';
  public searchIntervel: number | undefined;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private ArtistProductsService: ArtistProductsService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private seriesService: SeriesService,
    private categoryService: CategoryService,
    private artistService: ArtistsService,
    private connectionsService: ConnectionsService,
    private artistPortfolioProductsService: ArtistPortfolioProductsService,
    private consignmentService: ConsignmentService,
    @Inject(DOCUMENT) private document: Document,
    private ArtTypeService: ArtTypeService,
    private confirmationService: ConfirmationService,
    private subscriptionRulesService: SubscriptionRulesService,
    private transloco: TranslocoService
  ) {
    console.log('Selected Lol Products', this.selectedProduct);
    this.uerInformation = new ShareableProductLink();
  }

  public ngOnInit(): void {

    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      this.route.params.subscribe((params) => {
        if (params['artistId']) {
          this.artistId = params['artistId'];
        }
      });
    }
    this.isFreePlanUser = this.authService.isFreePlanUser();

    if (this.authConfig.IsArtist) {
      this.artistId = this.authService.getUserId();
      this.isArtist = true;
      // this.getArtistProductsSummaryResponse(this.artistId, this.filters);
      this.fetchConnectedGalleries(this.artistId, false);
    }
    if (this.authConfig.IsGallery) {
      this.galleryId = this.authService.getUserId();
      this.isGallery = true
      // this.getGalleryConsignmentProducts();
      this.getAllArtist();
    }
    this.NumberOfArtistPortfolios = this.authService.getNumberOfPortfolios()
    console.log(this.NumberOfArtistPortfolios)
    // this.uerInformation.NumberOfColumnToShow = 6;
    this.numberOfColumnToShow = 6
    this.getArtistArtTypeDropdownItems(this.artistId);
    // this.fetchConnectedGalleries(this.artistId, false);
    this.statusFilterOptions = [];
    this.statusFilterOptions.push({ label: 'Available', value: 'Available' });
    // this.statusFilterOptions.push({ label: 'Consigned', value: 'Consigned' });
    this.statusFilterOptions.push({ label: 'Sold', value: 'Sold' });
    // this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    this.getArtTypes();
    this.getPortFolioData();
    this.calculateTop();
  }


private getArtistProductsSummaryResponse(artistId: string, filters: ArtistProductsSummaryRequest) {
  this.loadingArtistProducts = true;
  this.ngxSpinnerService.show();
  // Ensure filters include pageSize of 1000 and status filter for available products
  const updatedFilters: ArtistProductsSummaryRequest = {
    ...filters,
    status: 'Available' // Explicitly filter for available products
  };

  this.ArtistProductsService.getArtistProductsSummaryResponse(artistId, updatedFilters).subscribe((artistProducts: ArtistProductSummary[]) => {
    this.artistProducts = artistProducts.map((product) => {
      product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
      return product;
    });
    this.removeSavedProductsFromInventory();
    this.ngxSpinnerService.hide();
    console.log(this.artistProducts, ':  artistProducts');
    this.loadingArtistProducts = false;
  },
    (error) => {
      console.error(error);
      this.loadingArtistProducts = false;
      this.ngxSpinnerService.hide(); // Hide spinner on error
    }
  );
}

  public getGalleryConsignmentProducts(artistId: string | null = null, filters: ConsignedProductsRequest = {}) {
    this.loadingGalleryProducts = true;
    this.ngxSpinnerService.show();
    console.log(artistId)
    this.consignmentService.getGalleryConsignmentProducts(artistId, filters).subscribe((galleryProducts: GalleryConsignmentProduct[]) => {
      console.log(galleryProducts)
      this.galleryProducts = galleryProducts.map(p => p.Product);
      this.galleryProducts = this.galleryProducts.map((product)=>{
        product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
        return product;
      });
      this.removeSavedProductsFromInventory()
      console.log('galleryProducts', this.galleryProducts);
      this.ngxSpinnerService.hide();
      this.loadingGalleryProducts = false;
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.loadingGalleryProducts = false; });
  }


  public onRowClick(portfolioId: string,isActive?: boolean): void {
    this.isActive = isActive
    console.log(this.isActive)
    this.portfolioId = portfolioId
    this.uerInformation.IsShowProfile = false;
    // this.showPortfolioProducts = true
    this.isEditPortfolioProducts = false
    this.selectedRowId = this.selectedRowId === portfolioId ? this.selectedRowId : portfolioId;
  }

  public selectInventory(event: ArtistProductSummary | ArtistProduct, inventoryType: 'artist' | 'gallery') {
    console.log("this.selectInventory",this.isEditPortfolioProducts)
    if (this.portfolioselections == false) {
      this.showProductDialog = true
      inventoryType === 'artist' ? this.selectedProduct = event as ArtistProductSummary : this.selectedGalleryProduct = event as ArtistProduct;
      console.log(inventoryType)
      return;
    }
    if(this.portfolioselections == true){
      console.log(this.isEditPortfolioProducts)
      this.showProductDialog = false
      const selectedInventory = inventoryType === 'artist' ? this.selectedArtistProductsInventory : this.selectedGalleryProductsInventory;
      const currentInventory = inventoryType === 'artist' ? this.artistProducts : this.galleryProducts;
      // console.log(this.showPortfolioProducts)
      // Check if the portfolio ID is empty (no portfolio selected)
    

        // Check if the product is already selected
      if (!selectedInventory.some((item) => item.Id === event.Id)) {
        // Check if the number of selected products exceeds the allowed limit
        if (selectedInventory.length >= this.productLimits) {
          this.isLimitDialogVisible = true; // This will show the dialog
          return; // Exit the function if the limit is reached
        }

        // Move the product to selectedInventory
        selectedInventory.push(event as ArtistProductSummary & ArtistProduct);

        // Add the product's ID to selectedProducts array
        this.selectedProducts.push(event.Id);
        console.log('Selected Product IDs:', this.selectedProducts);

        // Enable the save button if a product is selected
        this.savePortfolioProductsButton = true;

        // Remove the selected item from currentInventory
        const index = currentInventory.findIndex((item) => item.Id === event.Id);
        if (index !== -1) {
          currentInventory.splice(index, 1);
        }

        // Mark the product as selected
        this.isProductSelected = true;
      }
    }

  }

  public moveToCurrentInventory(event: ArtistProductSummary | ArtistProduct, inventoryType: 'artist' | 'gallery') {
    const selectedInventory = inventoryType === 'artist' ? this.selectedArtistProductsInventory : this.selectedGalleryProductsInventory;
    const currentInventory = inventoryType === 'artist' ? this.artistProducts : this.galleryProducts;

    // Find the index of the item in the selectedInventory array
    const currentIndex = selectedInventory.findIndex((item) => item.Id === event.Id);
    // If the item is found, remove it from selectedInventory and add it to currentInventory
    if (currentIndex !== -1) {
      const removedItem = selectedInventory.splice(currentIndex, 1)[0];
      // Remove the product's ID from selectedProducts array
      const idIndex = this.selectedProducts.findIndex((id) => id === removedItem.Id);
      if (idIndex !== -1) {
        this.selectedProducts.splice(idIndex, 1);
      }
      currentInventory.push(removedItem as ArtistProductSummary & ArtistProduct);
      this.isProductSelected = selectedInventory.length > 0;
      console.log('Selected Product IDs:', this.selectedProducts);
    }
  }

  public  editPortfolio(item: ShareableProductLink) {
    if (!item.IsActive) {
      console.log(item)
      this.portfolioselections = false
      this.selectedArtistProductsInventory = [];
      this.selectedGalleryProductsInventory = [];
      this.notificationsService.showNotification(
        this.transloco.translate('shareableProduct.errorTitle'),
        this.transloco.translate('shareableProduct.portfolioInactiveEdit'),
        NotificationTypes.Error
      );
       // Stop execution if portfolio is inactive
    }
    this.portfolioselections = true;
    this.isActive = item.IsActive
    // this.isActive = true
    this.showMenuButton = false;
    this.isShowProfile = false
    this.portfolioId = item.Id;
    this.selectedRowId = item.Id;
    this.isEditPortfolioProducts = true
    console.log("editPortfolio",this.isEditPortfolioProducts)
    // this.uerInformation.IsShowProfile = false;
    this.sidebarVisible = false;
    const baseUrl = this.document.location.origin;
    try {
      // First, fetch the artist portfolio products
      if (this.isArtist) {
          this.shareLink = `${baseUrl}/${this.artistId}/shareable-product/${item.Id}`;
          this.getArtistProtfolioProduct(item.Id); // Wait for artist products first
          
      }

      // After fetching artist portfolio products, fetch gallery products if it's a gallery
      if (this.isGallery) {
          this.shareLink = `${baseUrl}/${this.galleryId}/gallery-shareable-product/${item.Id}`;
          console.log("Fetching Gallery portfolio...");
          this.getArtistProtfolioProduct(item.Id); // Ensure artist portfolio is fetched first
          console.log("Gallery products fetched successfully.");
          
      }

      console.log('Portfolio item:', item); // Log the item after the API calls have completed
    } catch (error) {
        console.error('Error in editing portfolio:', error); // Log any errors
    }
    console.log(item);
    
  }

  public editPortfolioData(event: Event,Id: string){
    this.sidebarVisible = false
    event.stopPropagation();
    const portfolio = this.portfolioList.find((portfolio)=>portfolio.Id === Id)
    if(portfolio){
       console.log(portfolio)
       this.portfolio = {...portfolio}
       console.log(this.portfolio)
       this.isEditMode = true
       this.displayPortfolioDialog = true
    }
  }

  public selectePortfolio(item: ShareableProductLink) {
    // if (this.portfolioList[0].IsActive == false) {
    //   this.notificationsService.showNotification(
    //     'Error',
    //     'Portfolio is InActive and No Data Found',
    //     NotificationTypes.Error
    //   );
    //   return; // Do nothing and exit the method
    // }
    console.log(item)
    this.Title = item.Title
    // if (!item.IsActive) {
    //   this.notificationsService.showNotification(
    //     'Error',
    //     'Portfolio is Inactive and No Products Data Found',
    //     NotificationTypes.Error
    //   );
    //   return; // Exit the method if the portfolio is inactive
    // }
    this.portfolioselections = false;
    this.showMenuButton = true;
    this.sidebarVisible = false
    // this.uerInformation.IsShowProfile = false;
    this.isShowProfile = false;
    this.isEditPortfolioProducts == false
    this.portfolioId = item.Id; // Updated here to reset portfolioId
    // if(this.portfolioList[0].IsActive == true) {
      this.getArtistProtfolioProduct(item.Id); // Fetch associated products
    // }
    const baseUrl = this.document.location.origin;
    if (this.isArtist) {
      this.shareLink = `${baseUrl}/${this.artistId}/shareable-product/${item.Id}`;
    }
    if (this.isGallery) {
      console.log(item.Id)
      this.shareLink = `${baseUrl}/${this.galleryId}/gallery-shareable-product/${item.Id}`;
    }
  }

  public getArtistProtfolioProduct(Id: string) {
    this.selectedProducts = []; 
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService.getArtistProtfolioProduct(Id).subscribe(
      (response: ShareableProductLink) => {
        console.log(response)
        if(response){
          this.uerInformation =  response;
          this.BusinessName = this.uerInformation.BusinessName;
          this.ProfilePicture = this.uerInformation.ProfilePicture;
          this.SharedBy = this.uerInformation.CreatedBy;
          this.AboutMe = this.uerInformation.AboutMe;
          this.CreatedDate = this.uerInformation.CreatedDate;
          if(this.portfolioselections == false){
            this.numberOfColumnToShow = response.NumberOfColumnToShow;
          }
          this.isShowProfile = response.IsShowProfile;
          this.Title = response.Title
          this.SharedById = response.ShareById;
          this.UserName = response.UserName;
          if (this.numberOfColumnToShow == 0) {
            response.NumberOfColumnToShow === 2;
          }
          this.ngxSpinnerService.hide();
          this.selectedProducts = response.PortfolioProductsViewModel?.map((p) => p.ArtistProduct.Id) || [];
          if (this.selectedProducts.length === 0) {
            this.showMenuButton = false;
          } else {
            this.showMenuButton = true;
          }
  
          if (this.isArtist) {
            this.selectedArtistProductsInventory =  response.PortfolioProductsViewModel?.map((x: { ArtistProduct: ArtistProductSummary }) => x.ArtistProduct) || [];
            this.artistProducts = this.selectedArtistProductsInventory;
            this.artistProducts = this.artistProducts.map((product)=>{
              product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
              return product;
            });
            if(this.portfolioselections == true){
              this.numberOfColumnToShow = 0
              this.applyConfigrationSettings = false
              this.filters = {};
              this.selectedArtistId = undefined;
              this.filters.Status = '';
              this.filters.Query = '';
              this.filters.ProductCategory = '';
              this.filters.ArtTypeId = '';
              this.getArtistProductsSummaryResponse(this.artistId, this.filters); // You can run other related methods here if needed
            }
          } else if (this.isGallery) {
            this.selectedGalleryProductsInventory = response.PortfolioProductsViewModel?.map((x: { ArtistProduct: ArtistProductSummary }) => {
              const artistProductSummary = x.ArtistProduct;
              return {
                Id: artistProductSummary.Id,
                ArtistProductId: artistProductSummary.Id,
                SerialNumber: artistProductSummary.SerialNumber || '',
                ArtistId: artistProductSummary.ArtistId,
                Name: artistProductSummary.Name,
                ArtistRevenue: artistProductSummary.ArtistRevenue,
                ArtistShortDescription: artistProductSummary.ShortDescription || '',
                ArtistLongDescription: artistProductSummary.LongDescription || '',
                ArtistSocialMediaDescription: artistProductSummary.ArtistSocialMediaDescription || '',
                ProductImgUrl: artistProductSummary.ProductImgUrl,
                Length: artistProductSummary.Length,
                Width: artistProductSummary.Width,
                Height: artistProductSummary.Height,
                Weight: artistProductSummary.Weight,
                Category: artistProductSummary.Category,
                SeriesId: artistProductSummary.SeriesId || null,
                ClayId: artistProductSummary.ClayId || null,
                CreatedDate: artistProductSummary.CreatedDate,
                IsActive: artistProductSummary.IsActive,
                ArtTypeId: artistProductSummary.ArtTypeId,
                Comment: '',
                ArtTypeName: artistProductSummary.ArtTypeName,
                IsAccepted: false, 
                SelectedGlazes: artistProductSummary.SelectedGlazes,
                ArtistProductLog: [], 
                IsSyncToSquarePos: false, 
                IsSyncToShopify: false, 
                IsSyncToWooCommerce: false, 
                IsSyncToWix: false, 
                ArtistProductLogs: [], 
                ArtistProductImages: [] 
                
              };
            }) || [];
            
            this.galleryProducts = this.selectedGalleryProductsInventory;
            this.galleryProducts = this.galleryProducts.map((product)=>{
              product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
              return product;
            });
            if(this.portfolioselections == true){
              this.numberOfColumnToShow = 0
              this.applyConfigrationSettings = false
              this.filters = {};
              this.selectedArtistId = undefined;
              this.filters.Status = '';
              this.filters.Query = '';
              this.filters.ProductCategory = '';
              this.filters.ArtTypeId = '';
              this.artistId = '';
              this.getGalleryConsignmentProducts(this.artistId, this.filters); // Now fetch gallery products
            }
          
          }
        }else{
          this.artistProducts = [];
          this.galleryProducts = [];
          if((this.isArtist || this.isGallery) && this.portfolioselections == false){
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.errorTitle'),
              this.transloco.translate('shareableProduct.portfolioInactiveNoProducts'),
              NotificationTypes.Error
            );
          }
          this.ngxSpinnerService.hide();
        }
      },

      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error fetching portfolio products:', error);
      }
    );
  }

  public savePortfolioProducts(portfolioId: string): void {
    if (!portfolioId) {
      this.notificationsService.showNotification(
        this.transloco.translate('shareableProduct.errorTitle'),
        this.transloco.translate('shareableProduct.portfolioIdRequired'),
        NotificationTypes.Error
      );
      return;
    }
    if (this.selectedProducts.length === 0) {
      this.notificationsService.showNotification(
        this.transloco.translate('shareableProduct.warningTitle'),
        this.transloco.translate('shareableProduct.noProductsSelected'),
        NotificationTypes.Error
      );
      return;
    }
    console.log(portfolioId)
    this.ngxSpinnerService.show();
    const request: SavePortfolioProducts = {
      portfolioLinkId: portfolioId,
      productIds: this.selectedProducts, // Selected product IDs
    };
    console.log("request", request)
    this.artistPortfolioProductsService
      .savePortfolioProducts(request)
      .subscribe({
        next: (response: ResponseObject) => {
          this.ngxSpinnerService.hide();

          if (response.Success) {
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.successTitle'),
              this.transloco.translate('shareableProduct.portfolioProductsSaved'),
              NotificationTypes.Success
            );
            this.removeSavedProductsFromInventory()
            this.getPortFolioData(); // Refresh the portfolio list
          } else {
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.warningTitle'),
              this.transloco.translate('shareableProduct.portfolioProductsSavedNoData'),
              NotificationTypes.Error
            );
          }
        },
        error: (error) => {
          this.ngxSpinnerService.hide();
          this.notificationsService.showNotification(
            this.transloco.translate('shareableProduct.errorTitle'),
            this.transloco.translate('shareableProduct.failedSavePortfolioProducts'),
            NotificationTypes.Error
          );
        },
      });
  }

  private removeSavedProductsFromInventory() {
    const selectedProductIds = this.selectedProducts.map(product => product);
  
    // Remove from artistProducts
    this.artistProducts = this.artistProducts.filter(product => !selectedProductIds.includes(product.Id));
  
    // Remove from galleryProducts
    this.galleryProducts = this.galleryProducts.filter(product => !selectedProductIds.includes(product.Id));
  
    // Optionally clear selected products if you want
    // this.selectedProducts = [];
  }

  public copyLink() {
    const inputElement = document.getElementById(
      'shareLinkInput'
    ) as HTMLInputElement;
    inputElement.select();
    document.execCommand('copy');
    this.copied = true; // Set copied to true
  }

  public portfolioTableCopyLink(event: Event ,portfoliodata: portfolioData): void {
    event.stopPropagation();
    const Portfolio = this.portfolioList.find((portfolio) => portfolio.Id === portfoliodata.Id);
    if (!Portfolio) {
      console.error('Portfolio not found for ID:', portfoliodata.Id);
      this.notificationsService.showNotification(this.transloco.translate('shareableProduct.errorTitle'), this.transloco.translate('shareableProduct.portfolioNotFound'), NotificationTypes.Error);
      return;
    }
    const baseUrl = this.document.location.origin;
    if (this.isArtist) {
      this.sharePortfolioRowLink = `${baseUrl}/${this.artistId}/shareable-product/${Portfolio?.Id}`;
    } else if (this.isGallery) {
      this.sharePortfolioRowLink = `${baseUrl}/${this.galleryId}/gallery-shareable-product/${Portfolio?.Id}`;
    }
    console.log('Generated Shareable Link:', this.sharePortfolioRowLink);
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.sharePortfolioRowLink).then(
        () => {
          console.log('Link copied to clipboard successfully!');
          this.copiedRowLink = true; // Set copied to true
          this.notificationsService.showNotification(this.transloco.translate('shareableProduct.successTitle'), this.transloco.translate('shareableProduct.portfolioLinkCopied'), NotificationTypes.Success);
        },
        (error) => {
          console.error('Error copying to clipboard:', error);
          this.notificationsService.showNotification(this.transloco.translate('shareableProduct.errorTitle'), this.transloco.translate('shareableProduct.failedCopyPortfolioLink'), NotificationTypes.Error);
        }
      );
    } else {
      const inputElement = document.getElementById('copyRowLink') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = this.sharePortfolioRowLink; // Set the input value
        inputElement.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            console.log('Fallback: Link copied to clipboard successfully!');
            this.copiedRowLink = true;
            this.notificationsService.showNotification(this.transloco.translate('shareableProduct.successTitle'), this.transloco.translate('shareableProduct.portfolioLinkCopied'), NotificationTypes.Success);
          } else {
            console.error('Fallback: Failed to copy using execCommand');
            this.notificationsService.showNotification(this.transloco.translate('shareableProduct.errorTitle'), this.transloco.translate('shareableProduct.failedCopyShareableLink'), NotificationTypes.Error);
          }
        } catch (error) {
          console.error('Fallback Error:', error);
          this.notificationsService.showNotification(this.transloco.translate('shareableProduct.errorTitle'), this.transloco.translate('shareableProduct.failedCopyShareableLink'), NotificationTypes.Error);
        }
      } else {
        console.error('Input element not found for fallback copy.');
      }
    }
  }
  

  public getPortFolioData() {
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService.getPortFolioData().subscribe(
      (portfolioList: portfolioData[]) => {
        this.ngxSpinnerService.hide();
        console.log(portfolioList);
        this.isEditPortfolioProducts == false
        this.portfolioList = portfolioList;
        this.productLimits = this.portfolioList.length > 0 ? this.portfolioList[0].NoOfProductsAllowedToShare : 0;
        console.log('this.portfolioList', this.portfolioList);
        console.log('this.productLimits', this.productLimits);
        if (!this.portfolioList[0].IsActive) {
          this.onRowClick(this.portfolioList[0].Id)
          this.editPortfolio(this.portfolioList[0])
          this.artistProducts = []
          this.galleryProducts = []
          return; // Exit the method if the portfolio is inactive
        }
        // this.isNotificationShown = false
        if (this.portfolioList?.length > 0) {
          this.onRowClick(this.portfolioList[0].Id)
          // this.selectePortfolio(this.portfolioList[0])
          this.editPortfolio(this.portfolioList[0])
        }else if(this.portfolioList.length == 0){
          if(this.isArtist){
            this.getArtistProductsSummaryResponse(this.artistId, this.filters);
          }
          if(this.isGallery){
            this.getGalleryConsignmentProducts();
          }
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public savePortfolio(): void {
    if(!this.isEditMode){
      this.ngxSpinnerService.show();
      // Call the service to save the portfolio
      this.artistPortfolioProductsService.portfolioData(this.portfolio).subscribe(
        (response: ResponseObject) => {
          // Check if the response is successful
          if (response.Success) {
            console.log('Portfolio saved successfully:', response);

            // Show success notification to the user
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.successTitle'),
              this.transloco.translate('shareableProduct.portfolioSaved'),
              NotificationTypes.Success
            );

            // If there is response data, add it to the portfolio list
            if (response.ResponseData) {
              this.portfolioList.push(response.ResponseData);
            }
          } else {
            // If the response is successful but no data is returned
            console.warn('Portfolio saved but response data is empty:', response);
            this.isUpgreadAccountDialogVisible = true;
            // Show a warning notification
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.warningTitle'),
              this.transloco.translate('shareableProduct.portfolioSavedNoData'),
              NotificationTypes.Error // Changed to 'Warning' to match the context
            );
          }

          this.ngxSpinnerService.hide();
          this.closePortfolioDialog();
          this.getPortFolioData();
        },
        (error) => {
          // Log error in case of a failure
          console.error('Error saving portfolio:', error);
          // Show an error notification to the user
          this.notificationsService.showNotification(
            this.transloco.translate('shareableProduct.errorTitle'),
            this.transloco.translate('shareableProduct.failedSavePortfolio'),
            NotificationTypes.Error
          );
          // Hide the loading spinner and keep the dialog open in case of an error
          this.ngxSpinnerService.hide();
        }
      );
    }else{
      this.ngxSpinnerService.show();
      // Call the service to save the portfolio
      this.artistPortfolioProductsService.portfolioData(this.portfolio).subscribe(
        (response: ResponseObject) => {
          // Check if the response is successful
          if (response.Success) {
            console.log('Portfolio saved successfully:', response);

            // Show success notification to the user
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.successTitle'),
              this.transloco.translate('shareableProduct.portfolioSaved'),
              NotificationTypes.Success
            );

            // If there is response data, add it to the portfolio list
            if (response.ResponseData) {
              this.portfolioList.push(response.ResponseData);
            }
          } else {
            // If the response is successful but no data is returned
            console.warn('Portfolio saved but response data is empty:', response);
            // Show a warning notification
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.warningTitle'),
              this.transloco.translate('shareableProduct.portfolioSavedNoData'),
              NotificationTypes.Error // Changed to 'Warning' to match the context
            );
          }

          this.ngxSpinnerService.hide();
          this.closePortfolioDialog();
          this.getPortFolioData();
        },
        (error) => {
          // Log error in case of a failure
          console.error('Error saving portfolio:', error);
          // Show an error notification to the user
          this.notificationsService.showNotification(
            this.transloco.translate('shareableProduct.errorTitle'),
            this.transloco.translate('shareableProduct.failedSavePortfolio'),
            NotificationTypes.Error
          );
          // Hide the loading spinner and keep the dialog open in case of an error
          this.ngxSpinnerService.hide();
        }
      );
    }
  }


  public toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  public onProductShareDailog() {
    this.isProductShareDailogVisible = true;
  }

  public onCloseProductShareDailog($event: any) {
    this.isProductShareDailogVisible = $event;
  }

  public onShowPageConfigrationDailog() {
    this.isPageConfigrationDailogVisible = true;
  }

  public onClosePageConfigrationsDailog() {
    this.isPageConfigrationDailogVisible = false;
    this.uerInformation = new ShareableProductLink();
    this.isShowProfile = false;
    this.numberOfColumnToShow = null;
  }

  public onColumnCountChange(event: number | null) {
    console.log('Selected Column Count:', event);
    // this.uerInformation.NumberOfColumnToShow = event;
    this.numberOfColumnToShow = event
    this.applyConfigrationSettings = true
    // if(this.applyConfigrationSettings){
      this.ngxSpinnerService.show();
    this.artistPortfolioProductsService
      .updatePortfolioConfigrations(
        this.portfolioId,
        this.numberOfColumnToShow,
        this.isShowProfile
      )
      .subscribe(
        (response) => {
          if (response.Success) {
            this.ngxSpinnerService.hide();
            console.log(response);
            this.sidebarVisible = false;
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.successTitle'),
              response.ResponseMessage,
              NotificationTypes.Success
            );
            this.getArtistProtfolioProduct(this.portfolioId);
          } else {
            this.ngxSpinnerService.hide();
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.errorTitle'),
              response.ResponseMessage,
              NotificationTypes.Error
            );
          }
        },
        (error) => {
          this.ngxSpinnerService.hide();
          console.error('Failed to generate the link:', error);
        }
      );
    // }
  }

  public onShowProfileChange(event: any) {
    console.log('Show Profile:', event.checked);
    // this.uerInformation.IsShowProfile = event.checked;
    this.isShowProfile = event.checked
    this.ngxSpinnerService.show();
    this.artistPortfolioProductsService
      .updatePortfolioConfigrations(
        this.portfolioId,
        this.numberOfColumnToShow,
        this.isShowProfile
      )
      .subscribe(
        (response) => {
          if (response.Success) {
            this.ngxSpinnerService.hide();
            console.log(response);
            this.sidebarVisible = false;
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.successTitle'),
              response.ResponseMessage,
              NotificationTypes.Success
            );
            this.getArtistProtfolioProduct(this.portfolioId);
          } else {
            this.ngxSpinnerService.hide();
            this.notificationsService.showNotification(
              this.transloco.translate('shareableProduct.errorTitle'),
              response.ResponseMessage,
              NotificationTypes.Error
            );
          }
        },
        (error) => {
          this.ngxSpinnerService.hide();
          console.error('Failed to generate the link:', error);
        }
      );
  }

  public onShowShareableProductDailog() {
    this.isShareableProductDailogVisible = true;
  }

  public onCloseShareableProductDailog() {
    this.isShareableProductDailogVisible = false;
  }

  public onShowStripeDailog(){
    
  }

  public openPortfolioDialog() {
    this.sidebarVisible = false;
    if(this.isFreePlanUser){
      this.subscriptionRulesService.generatePortfolio().subscribe(
        (responce: boolean) => {
          // this.canGeneratePortolio = responce
          console.log(responce)
          if( responce){
            this.displayPortfolioDialog =true;
            this.portfolio.IsActive = true
          }else{
            this.isUpgreadAccountDialogVisible = true;
          }
        },
        (error) => {
        }
      );
    }else{
      this.displayPortfolioDialog =true;
      this.portfolio.IsActive = true
    }
  }
  public openProfileMenuSection() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  public closePortfolioDialog() {
    this.isEditMode = false
    this.displayPortfolioDialog = false;
    this.portfolio = new portfolioData();
  }


  public closeArtistSelectedProductDialog(): void {
    this.showProductDialog = false;
    console.log('Full screen image dialog closed');
  }

  private getArtistArtTypeDropdownItems(artistId: string) {
    this.artistArtTypes = [];
    this.artistService.getArtistArtTypeDropdownItems(artistId).subscribe(
      (artistArtTypes: SelectItem[]) => {
        this.artistArtTypes = artistArtTypes;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getAllSeries(artTypeId: string) {
    this.productSeries = [];
    this.seriesService.getAllSeries(artTypeId).subscribe(
      (seriesItems) => {
        this.productSeries = seriesItems.map((item) => {
          return { label: item.Name, value: item.Id };
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getAllCategoies(artTypeId: string) {
    this.productCategories = [];
    this.categoryService.fetchCategory(artTypeId).subscribe(
      (category) => {
        this.productCategories = category.map((item) => {
          return { label: item.Name, value: item.Id };
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private fetchConnectedGalleries(artistId: string, includeInvited: boolean) {
    this.connectionsService
      .getConnectedGalleries(artistId, includeInvited)
      .subscribe(
        (galleries) => {
          this.galleries = galleries.map((gallery) => {
            return { label: gallery.Name, value: gallery.Id };
          });
        },
        (error) => {
          console.error(error);
        }
      );
  }

  public onArtTypedChanged($event: SelectItem) {
    this.filters.ArtTypeId = $event.value;
    if (!this.filters.ArtTypeId) {
      //if no arttype is selected, reset the categories and series bindings alongwith the options
      this.filters.ProductSeriesId = undefined;
      this.filters.ProductCategory = undefined;
      this.productSeries = [];
      this.productCategories = [];
    } else {
      //if the user has selected the arttype, refresh the categories and series linked with the selected arttype
      this.getAllSeries(this.filters.ArtTypeId);
      this.getAllCategoies(this.filters.ArtTypeId);
    }

    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public onProductCategoriesChange($event: SelectItem) {
    this.filters.ProductCategory = $event.value;
    if (this.isArtist) {
      this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    if (this.isGallery) {
      this.getGalleryConsignmentProducts(this.artistId, this.filters);
    }
  }

  public onProductSeriesChange($event: SelectItem) {
    this.filters.ProductSeriesId = $event.value;
    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public onGalleriesChange($event: SelectItem) {
    this.filters.GalleryId = $event.value;
    this.getArtistProductsSummaryResponse(this.artistId, this.filters);
  }

  public onStatusFilterChange($event: any) {
    // this.filters.Status = $event.value;
    console.log(this.artistId)
    if (this.isArtist) {
      this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    if (this.isGallery) {
      this.getGalleryConsignmentProducts(this.artistId,this.filters);
    }
  }

  public onGlobalFilterProduct($event: any): void {
    // Check if the query has at least 3 characters
    if (this.filters.Query!.length >= 3) {
      if (this.isArtist) {
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
      }
      if (this.isGallery) {
        this.getGalleryConsignmentProducts(this.artistId, this.filters);
      }
    } else if (this.filters.Query?.length === 0) {
      // When the query is empty, call the API without filters
      if (this.isArtist) {
        this.getArtistProductsSummaryResponse(this.artistId, this.filters);
      }
      if (this.isGallery) {
        this.getGalleryConsignmentProducts(this.artistId, this.filters);
      }
    }
  }
  

  public clearAllFilters($event: any) {
    this.filters = {};
    this.selectedArtistId = undefined;
    this.filters.Status = '';
    this.filters.Query = '';
    this.filters.ProductCategory = '';
    this.filters.ArtTypeId = '';
    // this.artistId = '';
    if (this.isArtist) {
      this.getArtistProductsSummaryResponse(this.artistId, this.filters);
    }
    if (this.isGallery) {
      this.getGalleryConsignmentProducts();
    }
  }

  public navigateToViewProfile() {
    if (this.UserName && this.isArtist) {
      this.router.navigate(['/profile', this.UserName]);
      // this.router.navigate(['/artist/gallery/', this.SharedById,'/gallery-products']);
    } else if (this.SharedById && this.isGallery) {
      // this.router.navigate(['/artist', this.SharedById]);
      this.router.navigate(['/profile',this.SharedById]);
    }
  }

  private getAllArtist() {
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.connectedArtists = artists;
    }, (error) => { console.error(error); });
  }

  private getArtTypes() {
    var filterRoleBasedArttypes = false;
    this.artTypes = [];
    this.ArtTypeService.fetch(filterRoleBasedArttypes).subscribe(
      (artTypeItems) => {
        this.artTypes = artTypeItems.map((item) => {
          return { label: item.Name, value: item.Id };
        });
        console.log('ArtTypes: ', this.artTypes);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public onArtTypeChanged($event: SelectItem) {
    this.filters.ArtTypeId = $event.value;
    if (!this.filters.ArtTypeId) {
      this.filters.ProductCategory = undefined;
      this.productCategories = [];
    } else {
      this.getAllCategoies(this.filters.ArtTypeId);
    }
    this.getGalleryConsignmentProducts(this.artistId, this.filters);
  }

  public onArtistChanged($event: any) {
    this.selectedArtistId = this.connectedArtists.find(p => p.value == $event.value);
    this.getGalleryConsignmentProducts($event.value);
  }

  public updateShareableLink() {
    // console.log(this.uerInformation);
    // this.ngxSpinnerService.show();
    // this.artistPortfolioProductsService
    //   .updatePortfolioConfigrations(
    //     this.portfolioId,
    //     this.uerInformation.NumberOfColumnToShow,
    //     this.uerInformation.IsShowProfile
    //   )
    //   .subscribe(
    //     (response) => {
    //       if (response.Success) {
    //         this.ngxSpinnerService.hide();
    //         console.log(response);
    //         this.sidebarVisible = false;
    //         this.notificationsService.showNotification(
    //           'Success',
    //           response.ResponseMessage,
    //           NotificationTypes.Success
    //         );
    //         this.getArtistProtfolioProduct(this.portfolioId);
    //       } else {
    //         this.ngxSpinnerService.hide();
    //         this.notificationsService.showNotification(
    //           'Error',
    //           response.ResponseMessage,
    //           NotificationTypes.Error
    //         );
    //       }
    //     },
    //     (error) => {
    //       this.ngxSpinnerService.hide();
    //       console.error('Failed to generate the link:', error);
    //     }
    //   );
  }

  onDragStart(product: ArtistProductSummary | ArtistProduct, index: number, type: 'artist' | 'gallery'): void {
    this.dragStartIndex = index;
    console.log('Drag started:', product, 'at index:', index);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault(); // Allow dropping by preventing default action
  }

  onDrop(event: any, dropIndex: number, type: 'artist' | 'gallery'): void {
    if (this.dragStartIndex === null || this.dragStartIndex === dropIndex) {
      return; // Do nothing if no drag started or dropped on the same position
    }

    // Determine the inventory based on the type (artist or gallery)
    const inventory = type === 'artist' ? this.selectedArtistProductsInventory : this.selectedGalleryProductsInventory;

    // Swap the products at dragStartIndex and dropIndex
    const temp = inventory[this.dragStartIndex];
    console.log(temp);
    inventory[this.dragStartIndex] = inventory[dropIndex];
    inventory[dropIndex] = temp;
    console.log(inventory);

    // Update selected products
    this.selectedProducts = inventory.map(product => product.Id);

    // Reset dragStartIndex
    this.dragStartIndex = null;

    console.log('Updated Inventory:', inventory);
  }

  onDragEnd(event: DragEvent): void {
    this.dragStartIndex = null; // Reset the drag index when drag ends
  }

  public onCloseStripePaymentDailog($event: boolean){
    this.isStripePlansDialogVisible = $event
  }

  public onUpgradeAccount() {
    this.isStripePlansDialogVisible = true;
  }

  public onDeletePortfolio(Id: string){
    const portfolio = this.portfolioList.find((portfolio)=>portfolio.Id === Id)
    this.confirmationService.confirm({
      message: this.transloco.translate('shareableProduct.deletePortfolioConfirm', { title: portfolio?.Title }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.artistPortfolioProductsService.deletePortfolio(Id).subscribe((response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
              this.notificationsService.showNotification(this.transloco.translate('shareableProduct.successTitle'),response.ResponseMessage,NotificationTypes.Success);
              var index = this.portfolioList.findIndex((portfolio) => portfolio.Id == Id);
              if (index >= 0) {
                this.portfolioList.splice(index, 1);
                this.getPortFolioData()
                if(this.portfolioList.length == 0){
                  this.portfolioselections = false;
                  if(this.isArtist){
                    this.artistProducts = []
                  }else if(this.isGallery){
                    this.galleryProducts = []
                  }
                }
              }
            } else {
              this.notificationsService.showNotification(this.transloco.translate('shareableProduct.errorTitle'),response.ResponseMessage,NotificationTypes.Error);
            }
          },
          (error) => {console.error(error);this.ngxSpinnerService.hide();}
        );
      },
    });
  }
  
  public calculateTop(): void {
    // const pageHeight = window.innerHeight; // Get current page height
    // this.dynamicTop = `${pageHeight * 0.5}px`; // Set top as 30% of page height
  }

  public downloadPortfolio(portfolioId: string){
    const requestUrl = `${environment.BASE_API_PATH}/artistproductportfolio/external/${portfolioId}`;
    this.copyToClipboard(requestUrl);
    this.notificationsService.showNotification(this.transloco.translate('shareableProduct.successTitle'), this.transloco.translate('shareableProduct.portfolioLinkCopiedToClipboard', { url: requestUrl }) ,NotificationTypes.Success);
    // this.artistPortfolioProductsService.downloadPortFolioData(portfolioId).subscribe(response => {
    //   console.log(response)
    //   // this.copyToClipboard(response);
    //   // this.saveFile(response, 'portfolio-data.json');
    //   // const blob = new Blob([response], { type: 'application/json' });
    //   // const downloadUrl = window.URL.createObjectURL(blob);
    //   // if (downloadUrl) {
    //   //   this.copyToClipboard(downloadUrl);
    //   // } else {
    //   //   console.error('Download link not found in response');
    //   // }
    // }, error => {
    //   console.error('Download failed:', error);
    // });
  }

  private copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Download link copied to clipboard', text);
      // this.notificationsService.showNotification('Success','Portfolio link copied successfully',NotificationTypes.Success);
    }).catch(err => console.error('Failed to copy:', err));
  }
  

  private saveFile(blob: Blob, filename: string) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    console.log(link.download);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public onStatusChange($event: boolean){
    this.portfolio.IsActive = $event
  }


  

}
